import { render } from "./FlightSubmits.vue?vue&type=template&id=c51126dc"
import script from "./FlightSubmits.vue?vue&type=script&lang=js"
export * from "./FlightSubmits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__